import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Grid,
  ListItemText,
  TextField,
  Button,
  DialogActions,
} from "@material-ui/core";
import * as React from "react";
import {
  colors,
  getCategories,
  getEquipmentTypes,
} from "../constants/constants";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { EquipmentsService } from "../services/EquipmentsService";
import LoadingComponents from "../components/LoadingComponents";
import history from "../utils/history";

const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    gridList: {
      width: "auto",
      height: 150,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  company: any;
  inspections: any;
  quickPickItem: any;
  onClose: any;
  onSelectedOptions: any;
}
class AddQuickPicksDialog extends React.Component<Props> {
  state = {
    inspectionType: { label: "", value: "", categories: Array<any>() },
    equipment: "",
    inspectionName: "",
    category: { label: "", value: "" },
    equipments: new Array<any>(),
    isLoading: false,
  };

  componentDidMount = () => {
    this.getEquipments();
  };
  componentDidUpdate = (prevProps: any) => {
    if (prevProps.company._id !== this.props.company._id) {
      this.getEquipments();
    }
  };

  getEquipments = () => {
    const { company } = this.props;
    let equipmentsService: EquipmentsService = new EquipmentsService();
    this.setState({
      isLoading: true,
    });
    equipmentsService.getEquipmentByCompanyId(company._id).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.equipments) {
        this.setState({
          equipments: resp.equipments,
        });
      }
    });
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleListItemClick = () => {
    this.props.onClose();
  };

  openDashboard = () => {
    const { company } = this.props;
    history.push({
      pathname: `/segpi/dashboard`,
      state: {
        companyData: company,
        properties: {
          inspectionType: this.state.inspectionType,
          category: this.state.category,
          equipment: this.state.equipment,
        },
      },
    });
  };

  render() {
    const { open, dialogTitle, onClose, company, onSelectedOptions } =
      this.props;

    return (
      <Dialog
        fullWidth
        maxWidth={"md"}
        onClose={() => this.handleClose()}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <LoadingComponents isLoading={this.state.isLoading} />
        <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid
            container
            style={{ width: "100%", flexDirection: "row", display: "flex" }}
            justifyContent={"space-between"}
          >
            <Autocomplete
              freeSolo
              style={{ flex: 1, paddingRight: 5 }}
              options={company.inspectionTypes}
              onChange={(event: any, value: any) => {
                this.setState({
                  inspectionType: value,
                });
              }}
              getOptionLabel={(option) => option.label}
              renderOption={(option: any) => (
                <React.Fragment>
                  <ListItemText primary={option.label} />
                </React.Fragment>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  placeholder={"Select inspection type"}
                  style={{ width: "100%" }}
                />
              )}
            />
            {company.inspectionTypes &&
              this.state.inspectionType &&
              this.state.inspectionType.value && (
                <Autocomplete
                  freeSolo
                  style={{ flex: 1, paddingLeft: 5 }}
                  options={getCategories(
                    company.inspectionTypes,
                    this.state.inspectionType.value
                  )}
                  onChange={(event: any, value: any) => {
                    this.setState({
                      category: value,
                    });
                  }}
                  getOptionLabel={(option) => option.label}
                  renderOption={(option: any) => (
                    <React.Fragment>
                      <ListItemText primary={option.label} />
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      placeholder={"Select inspection category"}
                      style={{ width: "100%" }}
                    />
                  )}
                />
              )}
            {this.state.inspectionType &&
              this.state.inspectionType.value !== "AUDIT" &&
              this.state.inspectionType.value !== "COVID-19-SCREENING" &&
              this.state.inspectionType.value !== "PERSONAL" && (
                <Autocomplete
                  freeSolo
                  style={{ flex: 1, paddingLeft: 5 }}
                  options={getEquipmentTypes(this.state.equipments)}
                  onChange={(event: any, value: any) => {
                    this.setState({
                      equipment: value,
                    });
                  }}
                  getOptionLabel={(option) => option.name}
                  renderOption={(option: any) => (
                    <React.Fragment>
                      <ListItemText
                        primary={option.name}
                        secondary={option.type}
                      />
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      placeholder={"Select equipment"}
                      style={{ width: "100%" }}
                    />
                  )}
                />
              )}
            <Autocomplete
              freeSolo
              style={{ flex: 1, paddingLeft: 5 }}
              options={this.props.inspections.filter((itemObj: any) => {
                return (
                  itemObj.inspectionType === this.state.inspectionType.value &&
                  itemObj.category === this.state.category.value
                );
              })}
              onChange={(event: any, value: any) => {
                this.setState({
                  inspectionName: value.name,
                });
              }}
              getOptionLabel={(option) => option.name}
              renderOption={(option: any) => (
                <React.Fragment>
                  <ListItemText primary={option.name} />
                </React.Fragment>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  placeholder={"Inspection name"}
                  style={{ width: "100%" }}
                />
              )}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose()}>{"Cancel"}</Button>
          <Button
            onClick={() => {
              let _value = {
                inspectionName: this.state.inspectionName,
                inspectionType: this.state.inspectionType,
                category: this.state.category,
                equipment: this.state.equipment,
              };
              onSelectedOptions(_value);
            }}
          >
            {"Save"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(AddQuickPicksDialog);
